import PropTypes from 'prop-types'
import LinkButtonBox from '../ui/LinkButtonBox'
import './Publicar.css'

const categorias = [
  { nombre: 'Productos', icono: 'fa fa-archive', esScrap: false },
  { nombre: 'Servicios', icono: 'fa fa-paint-brush', esScrap: false },
  { nombre: 'Vehículos', icono: 'fa fa-car', esScrap: false },
  { nombre: 'Scrap', icono: 'fa fa-recycle', esScrap: true }
]

const CategoriasPrincipales = ({ onClick, selectedTipo }) => {
  return (
    <div className="row mt-3">
      {categorias.map((categoria) => (
        <div key={categoria.nombre} className="col-6 col-md-3 mb-3">
          <LinkButtonBox
            texto={categoria.nombre}
            className={`btn borde-normal-seleccion text-center categoria-principal-btn ${
              selectedTipo === categoria.nombre ? 'categoria-principal-btn--selected' : ''
            }`}
            classNameIcono={`${categoria.icono} icon-responsive`}
            onClick={() => onClick(categoria)}
          />
        </div>
      ))}
    </div>
  )
}

CategoriasPrincipales.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedTipo: PropTypes.string
}

export default CategoriasPrincipales
